import { render, staticRenderFns } from "./clipAttachment.vue?vue&type=template&id=3feea546&"
import script from "./clipAttachment.vue?vue&type=script&lang=js&"
export * from "./clipAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports